module.exports = __webpack_public_path__ + "static/media/17-d-calendar.459c52d0.jpg";